import classNames from 'classnames';
import CardContent from '@mui/material/CardContent';

import { Link } from '../Button';

import * as Styles from './Card.styles';

const Card = ({
  title,
  children,
  className = '',
  contentClassName = '',
  titleClassName = '',
  cardContentClassName = '',
  linkUrl = '',
  linkText = '',
  linkClassName = '',
  customTitle = null,
  id = undefined,
}) => {
  if (linkText) {
    return (
      <Styles.Card className={className} id={id}>
        <CardContent className={cardContentClassName}>
          {title ? (
            <div className="flex justify-between items-center">
              <Styles.CardTitle
                component="h3"
                className={classNames('card-title', titleClassName)}
              >
                {title}
              </Styles.CardTitle>
              <Link
                text={linkText}
                href={linkUrl}
                className={classNames('text-sm px-0', linkClassName)}
              />
            </div>
          ) : null}
          <div
            className={classNames(
              'w-full relative card-main-content',
              contentClassName,
              !title ? 'mt-0' : ''
            )}
          >
            {children}
          </div>
        </CardContent>
      </Styles.Card>
    );
  }

  return (
    <Styles.Card className={className} id={id}>
      <CardContent className={cardContentClassName}>
        {title ? (
          <Styles.CardTitle
            component="h3"
            className={classNames('card-title', titleClassName)}
          >
            {title}
          </Styles.CardTitle>
        ) : null}
        {customTitle || null}
        <div
          className={classNames(
            'w-full relative card-main-conten',
            contentClassName,
            !title ? 'mt-0' : ''
          )}
        >
          {children}
        </div>
      </CardContent>
    </Styles.Card>
  );
};

export default Card;
